var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.96875,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7042 8.20312H10.7292C9.86813 8.20312 9.17188 8.8829 9.17188 9.72336V27.7725C9.17188 28.613 9.86813 29.2969 10.7292 29.2969H28.7042C29.5652 29.2969 30.2656 28.613 30.2656 27.7766V9.72336C30.2656 8.8829 29.5652 8.20312 28.7042 8.20312ZM15.43 26.1781H12.2989V16.1092H15.43V26.1781ZM13.8644 14.7372C12.8592 14.7372 12.0475 13.9256 12.0475 12.9245C12.0475 11.9234 12.8592 11.1118 13.8644 11.1118C14.8655 11.1118 15.6772 11.9234 15.6772 12.9245C15.6772 13.9215 14.8655 14.7372 13.8644 14.7372ZM27.1469 26.1781H24.0199V21.2837C24.0199 20.1178 23.9993 18.614 22.3925 18.614C20.7652 18.614 20.518 19.8871 20.518 21.2013V26.1781H17.3951V16.1092H20.3944V17.4852H20.4356C20.8517 16.6942 21.8734 15.8578 23.3937 15.8578C26.5619 15.8578 27.1469 17.9425 27.1469 20.6534V26.1781Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/LinkdinIcon.1e384c4ae4bd77658237606e87d9eeca.svg";
export { ForwardRef as ReactComponent };